import { gql } from "@apollo/client";

export const GET_RACES_LIST = gql`
  query getRacesList(
    $wagerProfile: String!
    $sortBy: PastRaceListSort
    $entityRunnerId: String
  ) {
    pastRaces(
      entityRunnerId: $entityRunnerId
      profile: $wagerProfile
      sort: $sortBy
    ) {
      raceId: id
      raceDate: date
      date: postTime
      number
      track {
        id
        name
        code
      }
      video {
        replayFileName
      }
      distance {
        value
        code
      }
      surface {
        shortName
        defaultCondition
      }
      raceClass {
        shortName
      }
      type {
        code
      }
      purse
      results {
        runners {
          entityRunnerId
          biNumber
          runnerNumber
          finishPosition
          finishStatus
          scratched
          currentOdds {
            numerator
            denominator
          }
          timeform {
            postRaceReport
            accBeatenDistance
            accBeatenDistanceStatus
            accBeatenDistanceStatusAbrev
            winningDistance
            winningDistanceStatus
          }
          favorite
        }
      }
      numRunners
    }
  }
`;

export default GET_RACES_LIST;
